module.exports = __webpack_public_path__ + "static/media/zoe.d723458a.png";